<template>
    <app-tabela :itens="entregasLista" :campos="campos" :itensPorPagina="itensPorPagina" :mostrarFiltro="false"
        :bordered="false" :small="false">
        <template slot="nomeEntrega" slot-scope="data">
            {{ data.nomeEntrega }}
        </template>
        <template slot="situacao" slot-scope="data">
            <app-status :status="data.situacao.toUpperCase()"></app-status>
        </template>
        <template slot="botoes">
            <slot name="botoes"></slot>
        </template>
        <template slot="acoes" slot-scope="data">
            <btn-atualizar-entrega :dataServicos="dataServicos" :acao="acao" :entrega="data"
                @atualizarLista="atualizarEntregas()"
                @atualizarErros="$emit('atualizarErros', $event)"></btn-atualizar-entrega>
            <metas-entrega v-if="temAcessoMetas" :dataServicos="dataServicos" :permiteInserirMetas="permiteInserirMetas"
                :permiteCancelarMetas="permiteCancelarMetas" :entrega="data" :acao="acao"
                @atualizarLista="atualizarEntregas()">
            </metas-entrega>
            <slot name="acoes" v-bind="data"></slot>
        </template>
    </app-tabela>
</template>

<script>
import BtnAtualizarEntrega from './BtnAtualizarEntrega'
import BtnCancelarEvento from './BtnCancelarEvento'
import DocumentosEvento from './DocumentosEvento'
import MetasEntrega from './metas/MetasEntrega'

export default {
    components: {
        BtnAtualizarEntrega,
        BtnCancelarEvento,
        DocumentosEvento,
        MetasEntrega
    },

    props: {
        entregas: {
            type: Array,
            default: () => []
        },

        operacao: {
            type: String,
            default: () => 'D'
        },

        acao: {
            type: Object,
            default: () => ({})
        },

        dataServicos: {
            type: Object
        },

        permiteCancelarEventos: {
            type: Boolean,
            default: () => false
        },

        temAcessoDocumentosEvento: {
            type: Boolean,
            default: () => false
        },

        temAcessoMetas: {
            type: Boolean,
            default: () => false
        },

        permiteInserirMetas: {
            type: Boolean,
            default: () => false
        },

        permiteCancelarMetas: {
            type: Boolean,
            default: () => false
        },

        permiteInserirAtualizarEventos: {
            type: Boolean,
            default: () => false
        },

        permiteInserirCancelarDocumentosEvento: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'nomeEntrega',
                    label: 'Nome da Entrega',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'totalPrevisto',
                    label: 'Total Previsto(Unidades)',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'totalRealizado',
                    label: 'Total Realizado(Unidades)',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5,
            entregasLista: []
        }
    },

    methods: {
        atualizarEntregas() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterEntregasPorAcao(
                this.acao.idAcaoPlanoTrabalho)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.entregasLista = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter os entregas da ação.',
                                'ERRO',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    mounted() {
        if (this.entregas) {
            this.entregasLista = this.entregas
        }
    },

    watch: {
        entregas() {
            this.entregasLista = this.entregas
        }
    }
}
</script>
